import React, { useState } from 'react';
import cx from '../../../../styles';
import {gtmSend} from '../../../../helpers';

export const SingleChoiceCarouselPrePoll = ({pollChoices, voteHandler, match}) => {

    const [isVoted, setIsVoted] = useState(false);

    const onClickHandler = (pollId, choiceId) => {
        if(!isVoted){
            setIsVoted(true);
            document.getElementById(choiceId).classList.add('active');
            voteHandler(pollId, choiceId);
            gtmSend('dynamic', 'Poll Card', 'click-single-choice-carousel-poll', match.path);
        }
    }

    return (
        <div className={cx('pre-poll-state', 'single-choice-carousel')}>
            {
                pollChoices.map((choice) => {
                    return (
                        <div className={cx("poll-bar-row")} key={choice.id} id={choice.id}>
                            <div title={choice.message} className={cx("poll-bar")} onClick={()=> onClickHandler(choice.poll_id, choice.id)}>
                                <img src={choice.image} alt="" />
                                <span className={cx('poll-message')}>{choice.message}</span>
                            </div>
                            <span className={cx("radio-btn")} onClick={()=> onClickHandler(choice.poll_id, choice.id)}></span>
                        </div>
                    );
                })
            }
        </div>
    );
}

export const SingleChoiceCarouselPostPoll = ({votes, voteHandler}) => {
    return (
        <div className={cx('post-poll-state', 'single-choice-carousel')}>
            {
                votes.map((vote) => {
                    return (
                        <div className={cx("poll-bar-row", vote.user_choice == 1 ? "chosen" : "")} key={vote.choice_id}>
                            <div title={vote.message} className={cx("poll-bar")} onClick={()=> voteHandler(vote.poll_id, vote.choice_id)}>
                                <img src={vote.image} alt="" />
                                <span className={cx('poll-message')}>{vote.message}</span>
                            </div>
                            <div className={cx("vote-percent-wrapper")}>
                                <div className={cx('vote-bar')}><div style={{width: vote.percentage + "%"}}></div></div>
                                <div className={cx('vote-percent')}>{vote.percentage}%</div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}
